var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"web-link"}},[_vm._v(" Please wait while we load your content... ")])}
var staticRenderFns = []

export { render, staticRenderFns }